export const REASONS = [
	{
		id: 'option_1',
		value: 'Not relevant to my petition',
	},
	{
		id: 'option_2',
		value: 'Group not active',
	},
	{
		id: 'option_3',
		value: 'Group no longer exists',
	},
	{
		id: 'option_4',
		value: 'Member is count too low',
	},
	{
		id: 'option_5',
		value: 'Audience is too broad',
	},
];
